import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { coreSelectors } from 'app/core/state';
import { formatUserName } from 'app/core/utilities/user-util';

import { SceneService } from '../../services/scene.service';
import SoundControl from '../../sound-control';
import { ParticipantsState, selectors } from '../../state/app';

@Component({
  selector: 'app-sound-debugger',
  templateUrl: './sound-debugger.component.html',
  styleUrls: ['./sound-debugger.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SoundDebuggerComponent implements OnDestroy {
  private store = inject(Store);
  private sceneService = inject(SceneService);

  public musicVolume = 0;
  public participantsState: ParticipantsState = {};
  public userId?: string;

  private cdr = inject(ChangeDetectorRef);

  private destroyed$ = new ReplaySubject<boolean>(1);
  private soundControl = SoundControl.getInstance(this.sceneService);

  public constructor() {
    this.soundControl.musicVolumeChanged$.pipe(takeUntil(this.destroyed$)).subscribe((musicVolume) => {
      this.musicVolume = musicVolume;
      this.cdr.markForCheck();
    });

    this.store
      .select(coreSelectors.getUserId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((userId) => {
        this.userId = userId;
        this.cdr.markForCheck();
      });

    this.store
      .select(selectors.getParticipantMediaState)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((participantsState) => {
        this.participantsState = participantsState;
        this.cdr.markForCheck();
      });
  }

  public getUserName(id: string): string {
    const user = this.sceneService.sceneManager?.participants.get(id)?.user ?? {};
    return formatUserName(user);
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
